import { FilterChips } from 'shared/mui/Filter/FilterChips/FilterChips';

import { useOrderProviderExternalErrorsFilterFields } from './hooks/useOrderProviderExternalErrorsFilterFields';

export const OrderProviderExternalErrorsFilterChips: React.FC = () => {
  const fields = useOrderProviderExternalErrorsFilterFields();

  return <FilterChips fields={fields} />;
};
